// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-dots {
    display: flex;
    gap: .2rem;
    padding: .5rem 0;
  }
  
  .dot {
    width: .3rem;
    height: .3rem;
    background-color: var(--terciary-font);
    border-radius: .04rem;
    opacity: 0.5;
    animation: loading-animation 1s infinite ease-in-out;
  }
  
  .dot:nth-child(1) {
    animation-delay: 0s;
  }
  
  .dot:nth-child(2) {
    animation-delay: 0.4s;
  }
  
  .dot:nth-child(3) {
    animation-delay: 0.6s;
  }
  
  @keyframes loading-animation {
    0%, 100% {
      opacity: 0.6;
    }
  
    50% {
      opacity: 1;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/app/shared/loading-dots/loading-dots.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,qBAAqB;IACrB,YAAY;IACZ,oDAAoD;EACtD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,UAAU;IACZ;EACF","sourcesContent":[".loading-dots {\n    display: flex;\n    gap: .2rem;\n    padding: .5rem 0;\n  }\n  \n  .dot {\n    width: .3rem;\n    height: .3rem;\n    background-color: var(--terciary-font);\n    border-radius: .04rem;\n    opacity: 0.5;\n    animation: loading-animation 1s infinite ease-in-out;\n  }\n  \n  .dot:nth-child(1) {\n    animation-delay: 0s;\n  }\n  \n  .dot:nth-child(2) {\n    animation-delay: 0.4s;\n  }\n  \n  .dot:nth-child(3) {\n    animation-delay: 0.6s;\n  }\n  \n  @keyframes loading-animation {\n    0%, 100% {\n      opacity: 0.6;\n    }\n  \n    50% {\n      opacity: 1;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
